module.exports = __webpack_public_path__ + "static/media/headerSmallest.3588d538.jpg";